import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import LineCharts from 'modules/_shared/components/Charts/LineChart';
import BeneficiarySocietyValueSimulator from 'modules/beneficiaries/components/BeneficiarySocietyValueSimulator';

import { SocietyValue } from 'types';

import './BeneficiarySociety.scss';

type BeneficiarySocietyChartSectionProps = {
  chartData: Record<string, unknown>;
  chartOptions: Record<string, unknown>;
  isMobile: boolean;
  societyValue?: SocietyValue;
  valuation: number;
  onChangeSlider: (value: number[]) => void;
  onOpenSellView: () => void;
};

const BeneficiarySocietyChartSection: FC<
  BeneficiarySocietyChartSectionProps
> = ({
  chartData,
  chartOptions,
  isMobile,
  societyValue,
  valuation,
  onChangeSlider,
  onOpenSellView,
}) => {
  const { t } = useTranslate();

  return (
    <div className="nk-fmg-status px-0">
      <h6 className="nk-fmg-status-title">
        <em className="icon ni ni-chart-up" />
        <span>{t('IncentiveValueEvolution')}</span>
      </h6>

      <div className="">
        <div className="d-flex flex-column flex-md-row justify-content-around mb-2">
          <div className="d-flex flex-row">
            <em className="icon ni ni-circle-fill text-primary mr-2 beneficiary-society-chart-legend-icon" />
            <span className="sub-text text-capitalize beneficiary-society-chart-legend-label">
              {t('TotalIncentiveValue')}
            </span>
            <em
              className="card-hint icon ni ni-help ml-1 beneficiary-society-chart-hint-icon"
              data-bs-toggle="tooltip"
              data-bs-placement="left"
              title={t('IncentiveValueLegendInfo')}
            />
          </div>

          <div className="d-flex flex-row">
            <em className="icon ni ni-circle-fill text-teal mr-2 beneficiary-society-chart-legend-icon" />
            <span className="sub-text text-capitalize beneficiary-society-chart-legend-label">
              {t('ActualVestedValue')}
            </span>
            <em
              className="card-hint icon ni ni-help ml-1 beneficiary-society-chart-hint-icon"
              data-bs-toggle="tooltip"
              data-bs-placement="left"
              title={t('ConsolidatedValueLegendInfo')}
            />
          </div>
        </div>

        <LineCharts
          data={chartData}
          options={chartOptions}
          height={isMobile ? 300 : undefined}
        />

        {isMobile && societyValue && (
          <>
            <hr className="mt-5" />
            <BeneficiarySocietyValueSimulator
              societyValue={societyValue}
              valuation={valuation}
              onChange={onChangeSlider}
              onClickSimulatorButton={onOpenSellView}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default BeneficiarySocietyChartSection;
